module.exports = __webpack_public_path__ + "static/media/miniwave-policie-blue.df27ee8a.svg";